export const SET_USER_APPLICATIONS = 'SET_USER_APPLICATIONS';
export const UPADTE_USER_APPLICATIONS_BLOBURL =
  'UPADTE_USER_APPLICATIONS_BLOBURL';
export const SET_USER_APPLICATION = 'SET_USER_APPLICATION';
export const UPDATE_USER_APPLICATION = 'UPDATE_USER_APPLICATION';
export const UPDATE_SINGLE_APPLICATION = 'UPDATE_SINGLE_APPLICATION';
export const UPDATE_USER_APP_LOGBOOK = 'UPDATE_USER_APP_LOGBOOK';
export const CHANGE_STATUS = 'CHANGE_STATUS';
export const UPDATE_TIME = 'UPDATE_TIME';
export const UPDATE_APP = 'UPDATE_APP';
export const ADD_REVIEW = 'ADD_REVIEW';
export const SET_BTN_LOADER_STUDENT = 'SET_BTN_LOADER_STUDENT';
export const SET_STUDENT_LOGBOOK_COMMENT_RES =
  'SET_STUDENT_LOGBOOK_COMMENT_RES';
export const SET_SNACKBAR_STATE_FOR_ACTIVITY_TAB =
  'SET_SNACKBAR_STATE_FOR_ACTIVITY_TAB';
